export let api_urls;

if (window.location.protocol === 'http:') {
    api_urls = 'https://goastrobackend.onrender.com/';
} else if (window.location.protocol === 'https:') {
    api_urls = 'https://goastrobackend.onrender.com/';
} else {
    console.log('Unknown protocol');
};